<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 5 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g transform="matrix(1.82427,0,0,1.82427,-0.54039,-0.554722)">
        <path
          d="M0.36,9L1.392,3L2.52,3L1.5,9L0.36,9ZM2.28,1.728C2.096,1.728 1.936,1.66 1.8,1.524C1.664,1.38 1.596,1.216 1.596,1.032C1.596,0.84 1.664,0.68 1.8,0.552C1.936,0.416 2.096,0.348 2.28,0.348C2.472,0.348 2.632,0.416 2.76,0.552C2.896,0.68 2.964,0.84 2.964,1.032C2.964,1.216 2.896,1.38 2.76,1.524C2.632,1.66 2.472,1.728 2.28,1.728Z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ItalicIcon'
}
</script>
